export default ['$uibModalInstance', 'config', 'onApprove', 'onDecline', function ($uibModalInstance, config, onApprove, onDecline) {
  this.title = 'Подтвердите подключение услуги "Сдай / Сними"';

  this.isDocsRequired = Boolean(config.get('homeowners.requireDocs.enabled'));
  this.ofertaUrl = config.get('dealV2.ofertaUrl');
  this.rulesApproved = false;

  this.onApprove = () => {
    onApprove();
    $uibModalInstance.dismiss();
  };

  this.onDecline = () => {
    onDecline();
    $uibModalInstance.dismiss();
  };
}];
